import { Container, Button,Form, Alert,Table} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import { FaFilePdf } from 'react-icons/fa';
import useBackend, {CallAPI, Loading, SpinnerX, CheckInvoice} from '../../services/useBackend';
import React from 'react';

class MyComponent extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
          data: null,
          isLoading: false,
          error: null,
          resultVariant :"success",
          resultVisible:false,
          resultText :'N/A',
          spinnerHidden:false,
          invoices:null,
          showUnpaidBanner:false,
          accountIsLocked:false
        }
    }

    CheckAccessToken;

    componentDidMount() {
        this.getData();
    }

    getData = () =>{
      this.setState({ resultVisible:false, spinnerHidden:false  });
      fetch('/backend/invoices/Instance', {
        method: 'GET',
        headers: {
           'Content-Type': 'application/json',
           'accessToken':localStorage.getItem('access_token'),
        },
     }).then(response => response.json())
     .then(data => {
        if (data.errorsException===false) {
            this.setState({ resultVariant :'success', resultVisible:false, resultText: data.resultText, spinnerHidden:true, invoices:data.invoicesList, showUnpaidBanner:data.showUnpaidBanner, accountIsLocked:data.accountIsLocked  });
        } else {
            this.setState({ resultVariant :'warning', resultVisible:true, resultText: data.resultText, spinnerHidden:true  });
        }
     })
     .catch(error => {
        this.setState({ resultVariant :'warning', resultVisible:true, resultText: 'Ett fel uppstod!', spinnerHidden:true  });
      });
    }

    anchorClickHandler = (event)  =>  { 
        const InvoiceGUID = event.currentTarget.getAttribute("InvoiceGUID")
        window.open("/backend/invoices/"+InvoiceGUID, "_"+InvoiceGUID);
    }

    render() {
        if (this.state.invoices !== null) {
            return (
                <ContentWrapper>
                    <Container>
                        <Sida>
                            <Rubrik>Mina Fakturor</Rubrik>
                            {this.state.showUnpaidBanner==true && this.state.accountIsLocked==false && <Alert variant="danger"><b>Förfallna fakturor!</b><br />Tjänsteleveransen kommer inom kort att ställas in och kommer återstartas först efter att betalning för aktuella fakturor och återstartsavgift (2500:-) bokförts på Cloudsolution Nordic ABs konto.</Alert> }
                            {this.state.accountIsLocked==true && <Alert variant="danger"><b>Tjänsteleveransen är inaktiverad!</b><br />Tjänsteleveransen är inaktiverad i väntan på att förfallna fakturor regleras. Tjänsten kommer aktiveras automatiskt när förfallna fakturor bokförts som betalda på Cloudsolution Nordic ABs konto.</Alert> }

                            <Table  responsive="sm">
                                <thead>
                                    <tr><td><small>#</small></td><td><small>Förfaller</small></td><td><small>Betald</small></td><td><small>PDF</small></td></tr>
                                </thead>
                                <tbody>
                                    {this.state.invoices.map((item) => {
                                        return <tr><td>{item.identifier}</td><td>{item.dayToPay}</td><td><CheckInvoice checked={item.payed} /></td><td><span className='sub' invoiceGUID={item.guid} onClick={this.anchorClickHandler}><FaFilePdf /></span></td></tr> 
                                    })}
                                </tbody>
                            </Table>
                            <small>Belopp angiva exklusive moms.</small>
                        </Sida>
                    </Container>
                </ContentWrapper>
            );
        } else {
            return (
                <ContentWrapper>
                    <Container>
                        <Sida>
                            <Rubrik>Mina Fakturor</Rubrik>

                            <Stycke>
                                Inga fakutor hittades!
                            </Stycke>    

                        </Sida>
                    </Container>
                </ContentWrapper>     
            );                       
        }
    }
}

export default MyComponent;